export default {
    title: "Colombia Transactions",
    subtitle: "PSE",
    path: "pse_transactions",
    paragraphs: [
      "PSE is a payment method that allows the customer to make almost instant payments in Colombia, directly from their bank account. Since the PSE has the payer information attached, some contact information fields will be needed and validated from the subject_id. You can check it in 'Information needed for registration (Person)' which information we ask for PSE payments.",
      "Apart from the URL, other information related to the payment will also be present among the transaction data. You can use it to keep your customer informed of the payment information and references.",
      "The whole process takes place on the same page. After sending the payload you will receive a URL with the payment link for the customer to pay with PSE. The steps for the payment after entering the link are listed below:",
      "1. In your checkout page, when the customer is trying to make a payment, a list of bank codes and names is retrieved and listed to the customer;",
      "2. The customer selects his bank code, and you’ll send the payload for the PSE transaction to us. When the transaction is created, in the response a bank payment URL is presented;",
      "3. You'll share this URL with the customer, and he will be redirected to his/her bank website to make the payment; The link will work only once, for 21 minutes. If the customer visits and closes the window before completing the payment, another payment will need to be generated.",
      "4.The customer will authenticate the payment in their bank and proceed with the payment.",
      "5. Once the payment is made and confirmed by the customer, he will be automatically redirected to the specified URL in the transaction payload (your checkout page from the beginning). In up to 3 minutes, the 'identified' webhook will also be received."
    ],
    hyperlink: {
      linkPath: "/static/documentation/PSE Checkout Guide.pdf",
      linkText: "You can also check this flow in this PDF Guide"
    },
    request: {
      method: "POST", 
      endpoint: "/transactions",
      payload: {
        "transaction": {
          "currency": "COP",
          "exchange_currency": "USD",
          "value": "850000",
          "from_pse": {
            "financial_institution_code": "1077",
            "redirect_url": "your website checkout page", 
            "payment_description": "Some description"
          },
          "to_bank_account_id": "COP/USD cash-in internal account id",
          "subject_id": "Customer id"
        }
      },
      responses: {
        "data": {
          "value": "850000",
          "to_bank_account": {
            "routing_number": null,
            "pix_info": null,
            "owner_name": "REARDEN STEEL CO.",
            "owner_document_number": "2348909854385",
            "owner_company": {
                "social_name": "POWER HOME THEATER",
                "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
                "document_type": "tax_id",
                "document_number": "2348909854385"
            },
            "nickname": null,
            "internal": true,
            "intermediary_bank_account": null,
            "id": "1ae24ce1-0a08-4c70-8aaa-c86d89ab32fa",
            "iban": null,
            "flow_type": "cash_in",
            "currency": "USD",
            "branch_number": null,
            "branch_country": "COL",
            "bank": {
              "swift": null,
              "name": "Internal",
              "ispb": null,
              "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
              "country": "COL",
              "code": "999"
            },
            "account_type": "conta-corrente",
            "account_number": null,
            "aba": null
          },
          "subject_is_receiver": false,
          "subject_id": "b40e39db-9e7e-4156-88b9-9f8035c3083f",
          "subject": {
            "updated_at": "2024-10-11T19:16:27.662717",
            "status": "approved",
            "social_name": "Samuel Giraldo",
            "rfc_pf": null,
            "required_clearance_level": 2,
            "references": [],
            "phone_number": "38547284",
            "net_monthly_average_income": "0.00",
            "inserted_at": "2023-09-21T12:27:34.464365",
            "id": "b40e39db-9e7e-4156-88b9-9f8035c3083f",
            "fiscal_country": "Colombia",
            "email": "giraldo@globo.co",
            "document_type": "cc",
            "document_number": "1037633285",
            "clearance_level": 2,
            "birth_date": null,
            "address_street": "Cr 19",
            "address_state": "Armenia",
            "address_postal_code": "63001",
            "address_number": "1N",
            "address_neighborhood": "Cali Bajo",
            "address_country": "Colombia",
            "address_complement": "L 14",
            "address_city": "Armenia"
          },
          "status": "pending",
          "source_name": "Samuel Giraldo",
          "source_document_type": "cc",
          "source_document_number": "1037633285",
          "from_pse": {
            "bank_name": "BANKA",
            "creation_date": "2024-10-11",
            "payment_description": "Some description",
            "payment_url": "https://registro.desarrollo.pse.com.co/PSENF/index.html?enc=qjv4QWD38K9atOF4VWIlw2%2bJNppHqvIffA%2fOFpqf5Tk%3d",
            "ticket_id": 10014,
            "trazability_code": "4358727"
          },
          "meta": {},
          "inserted_at": "2024-10-11T19:16:27.644009",
          "id": "261750da-68af-4566-b143-6d19846b9541",
          "from_credit_card": null,
          "from_bank_account": {
            "routing_number": null,
            "pix_info": null,
            "owner_name": null,
            "owner_document_number": null,
            "nickname": null,
            "intermediary_bank_account_id": null,
            "id": "00000000-0000-0000-0000-000000000025",
            "iban": null,
            "currency": "COP",
            "branch_number": "5",
            "branch_country": null,
            "bank": {
              "swift": null,
              "name": "BANCOLOMBIA QA",
              "ispb": null,
              "id": "cb45e068-2010-44e0-a12b-91dd40f56ef7",
              "country": "COL",
              "code": "1007"
            },
            "account_type": "conta-corrente",
            "account_number": "6789",
            "aba": null
          },
          "for_exchange": true,
          "exchange_under_request": false,
          "exchange_currency": "USD",
          "estimated_value_until_exchange": false,
          "currency": "COP",
          "cleared": true,
          "bank_transaction": null
        }
      }
    },
    parameterPayload: [
    {
      name: "transaction",
      type: "object",
      required: true,
      description: "An object containing all the required values needed"
    },
    {
      name: "transaction.currency",
      type: "string",
      required: true,
      description: "Source currency for the transaction (ISO 4217 format)"
    },
    {
      name: "transaction.exchange_currency",
      type: "string",
      required: true,
      description: "Currency to be exchanged (ISO 4217 format)"
    },
    {
      name: "transaction.value",
      type: "string",
      required: true,
      description: "Value to be exchanged (in the source currency)"
    },
    {
      name: "transaction.from_pse",
      type: "object",
      required: true,
      description: "An object, containing the following parameters:"
    },
    {
      name: "transaction.from_pse.financial_institution_code",
      type: "string",
      required: true,
      description: "Bank code obtained using the PSE banks endpoint. More info on this in the next section."
    },
    {
      name: "transaction.from_pse.redirect_url",
      type: "string",
      required: true,
      description: "The URL from your website/platform in which the customer will be redirected upon finishing payment"
    },
    {
      name: "transaction.from_pse.payment_description",
      type: "string",
      required: false,
      description: "Any description with up to 80 characters related to the payment. Will be displayed on the confirmation page and recorded among the transaction information."
    },
    {
      name: "transaction.to_bank_account_id",
      type: "string",
      required: true,
      description: "ID of the account you will send the funds after the PSE is paid"
    },
    {
      name: "transaction.subject_id",
      type: "string",
      required: true,
      description: "ID of your customer¹"
    }
  ],
  domainsProperties: [
    {
      name: "social_name",
      values: "Maximum length of 64 characters."
    },
    {
      name: "address_street + address_number + address_complement + address_city",
      values: "Maximum length of 64 characters."
    },
    {
      name: "email",
      values: "Maximum length of 120 characters. Notice that this e-mail will receive receipts and OTP codes even in sandbox mode, so provide a valid e-mail address when testing."
    },
    {
      name: "phone_area_code",
      values: "Maximum length of 3 characters."
    },
    {
      name: "phone_number",
      values: "Maximum length of 7 characters."
    },
  ],
  footerNotes: "¹This subject must have the following attributes filled: address_street, address_number, phone_area_code, phone_number and email."
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPse.js